import { useToast } from "shared/toast/useToast";
import { useRouteChange } from "../useRouteChange";

export default function ClearAlertsOnRouteChange() {
  const { clear } = useToast();
  useRouteChange(() => {
    clear();
  });
  return null;
}
